export const truncateDataValue = (value: number) => {
  return value.toFixed(3);
};
